define('commentsTagsView',[
  'module',
  'backbone',
  'underscore',
  'marionette',
  'commentsTagView',
  'commentsTags'
], function (
  Module,
  Backbone,
  _,
  Marionette,
  TagView,
  Tags
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    childView: TagView,
    className: 'comments-tags-view',

    childEvents: {
      'click': function (childView, model) {  
        if(!this.options.multiSelect) {         
          this.collection.each(function (model) {
            model.set('selected', false);
          });
          model.set('selected', true);

          _.each(this.tags, function (item) {
            if(item.id === model.get('id'))
              item.selected = true;
            else
              item.selected = false;
          }, this);
        } else {       
          model.set('selected', !model.get('selected'));
          _.each(this.tags, function (item) {
            if(item.id === model.get('id'))
              item.selected = model.get('selected');
          }, this);
        }

        this.trigger('change', model);
      }
    },  

    childViewOptions: function () {
      return {
        showDeleteButton: this.options.showDeleteButton
      };
    },

    initialize: function () {
      this.collection = new Backbone.Collection();      
      this.tags = Tags.get(this.options.showAll);
    },

    onShow: function () {
      this.fetch();
    },

    fetch: function () {    
      var tags = [];      
      _.each(this.tags, function (tag) {
        if(tag.visible || tag.id === '')
          tags.push(tag);
      }, this);
      this.collection.reset(tags);
    },

    setSelected: function (id, value = true) {
      this.collection.each(function (model) {
        if(model.get('id') === id) 
          model.set('selected', value);
      });

      _.each(this.tags, function (item) {
        if(item.id === id)
          item.selected = value;
      }, this);
    },

    getSelected: function () {
      var selected = null;
      if(this.options.multiSelect) {        
        selected = [];
        this.collection.each(function (model) {
          if(model.get('selected') === true)
            selected.push(model);
        });
        return selected;
      } else {
        selected = this.collection.findWhere({selected: true});
        if(selected)
          return selected;
        else
          return null;
      }
    }
  });
});
